<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">學生登錄統計</h1>
      </div>
    </div>

    <div class="layout">
      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <div class="search-row">
          <el-date-picker
              style="width: 326px;"
              size="small"
              clearable
              v-model="listQuery.dateValue"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="登錄日期開始"
              end-placeholder="登錄日期截止"
              :pickerOptions="pickerOptions"
          ></el-date-picker>

          <!-- 統計維度：新增每日 -->
          <el-select v-model="listQuery.statType" size="small" style="width:140px" placeholder="統計維度" @change="onSearch">
            <el-option label="每分鐘" value="minute"></el-option>
            <el-option label="每小時" value="hour"></el-option>
            <el-option label="每日" value="day"></el-option>
          </el-select>

          <div class="search-buttons">
            <el-button size="small" type="warning" @click="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 新增總數統計卡片 -->
      <div class="total-card">
        <div class="total-item">
          <span class="total-label">區間登錄總次數</span>
          <span class="total-num">{{ totalLoginCount }}</span>
        </div>
        <div class="total-item">
          <span class="total-label">登錄獨立學生數</span>
          <span class="total-num">{{ distinctStudentCount }}</span>
        </div>
        <div class="total-item">
          <span class="total-label">當前統計維度</span>
          <span class="total-num">{{ statTypeText }}</span>
        </div>
      </div>

      <!-- 登錄趨勢折線圖 原生容器 -->
      <div class="chart-card">
        <h3 class="chart-title">區間{{ statTypeText }}登錄人次走勢</h3>
        <div ref="chartDom" class="login-chart"></div>
      </div>

      <!-- 统一风格 PC表格 -->
      <div class="table-container">
        <div class="pc-table">
          <el-table
              :data="tableData"
              style="width:100%"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無數據' : ''"
          >
            <el-table-column label="#" type="index" width="50" align="center"></el-table-column>
            <el-table-column prop="createdAt" label="登錄日期" align="center" min-width="120">
              <template slot-scope="{ row }">
                {{ formatDateTime(row.createdAt.date) }}
              </template>
            </el-table-column>
            <el-table-column prop="userNo" label="學生賬號" align="center" min-width="120"></el-table-column>
            <el-table-column prop="userName" label="學生名字" align="center" min-width="120"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import { getCardsNumUser } from "@/api/setting";
import { formatDateTime } from "@/filters";

export default {
  computed: {
    statTypeText() {
      const map = {
        minute: '每分鐘',
        hour: '每小時',
        day: '每日'
      }
      return map[this.listQuery.statType] || ''
    }
  },
  data() {
    return {
      chartInstance: null,
      totalLoginCount: 0, // 總登錄次數
      distinctStudentCount: 0, // 去重學生總數
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= Date.now();
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一個月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三個月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 6);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30 * 12);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      listQuery: {
        dateValue: '',
        statType: 'minute' // 預設分鐘維度
      },
      tableData: [],
      chartOption: {
        tooltip: {
          trigger: 'axis',
          formatter: '{b}<br/>登錄人次：{c}'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLabel: {
            rotate: 45,
            interval: 'auto'
          }
        },
        yAxis: {
          type: 'value',
          name: '登錄人次'
        },
        series: [
          {
            name: '登錄人數',
            type: 'line',
            smooth: true,
            data: [],
            itemStyle: {
              color: '#B62D2E'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(182,45,46,0.3)' },
                  { offset: 1, color: 'rgba(182,45,46,0.05)' }
                ]
              }
            }
          }
        ]
      }
    };
  },
  mounted() {
    // 預設今日日期區間
    const today = new Date();
    const dayStr = this.getDayStr(today);
    this.listQuery.dateValue = [dayStr, dayStr];

    this.initChart();
    window.addEventListener('resize', () => {
      this.chartInstance && this.chartInstance.resize();
    });
    // 頁面載入自動查詢今日數據
    this.getCountLoginStudentNumber();
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
    window.removeEventListener('resize', this.resize);
  },
  methods: {
    initChart() {
      const dom = this.$refs.chartDom;
      if (!dom) return;
      this.chartInstance = echarts.init(dom);
      this.chartInstance.setOption(this.chartOption);
    },
    refreshChart(xData, yData) {
      this.chartOption.xAxis.data = xData;
      this.chartOption.series[0].data = yData;
      // 動態修改系列名稱
      this.chartOption.series[0].name = `${this.statTypeText}登錄人數`
      this.chartInstance.setOption(this.chartOption);
    },
    getDayStr(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },
    // 新增：純日期格式 yyyy-MM-dd
    getDateStr(date) {
      return this.getDayStr(date)
    },
    // 分鐘格式 yyyy-MM-dd HH:mm
    getMinuteStr(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}`;
    },
    // 小時格式 yyyy-MM-dd HH點
    getHourStr(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      return `${y}-${m}-${d} ${h}點`;
    },
    formatDateTime(cellValue) {
      return formatDateTime(new Date(cellValue), 'dd/MM/yyyy HH:mm:ss');
    },
    // 根據選擇維度聚合數據
    aggregateChartData(list) {
      const timeMap = {};
      list.forEach(item => {
        const time = new Date(item.createdAt.date);
        let timeKey = '';
        if (this.listQuery.statType === 'minute') {
          timeKey = this.getMinuteStr(time)
        } else if (this.listQuery.statType === 'hour') {
          timeKey = this.getHourStr(time)
        } else if (this.listQuery.statType === 'day') {
          timeKey = this.getDateStr(time)
        }
        timeMap[timeKey] = (timeMap[timeKey] || 0) + 1;
      });
      // 時間排序
      const sortedKeys = Object.keys(timeMap).sort((a, b) => new Date(a) - new Date(b));
      const xData = sortedKeys;
      const yData = sortedKeys.map(k => timeMap[k]);
      this.refreshChart(xData, yData);
    },
    onSearch() {
      this.getCountLoginStudentNumber();
    },
    onReset() {
      // 重置後恢復默認今日 + 每分鐘
      const today = new Date();
      const dayStr = this.getDayStr(today);
      this.listQuery.dateValue = [dayStr, dayStr];
      this.listQuery.statType = 'minute';
      this.tableData = [];
      // 清空統計總數
      this.totalLoginCount = 0;
      this.distinctStudentCount = 0;
      this.refreshChart([], []);
      this.getCountLoginStudentNumber();
    },
    getCountLoginStudentNumber() {
      if (!this.listQuery.dateValue || this.listQuery.dateValue.length !== 2) return;
      const listQuery = {
        type: 1,
        startDate: this.convertToDateTimeStr(this.listQuery.dateValue[0]) + ' 00:00:00',
        endDate: this.convertToDateTimeStr(this.listQuery.dateValue[1]) + ' 23:59:50',
      };
      getCardsNumUser(listQuery).then(v => {
        const resList = v.data || [];
        this.tableData = resList;

        // 計算總登錄次數、去重學生數
        this.totalLoginCount = resList.length;
        const studentSet = new Set();
        resList.forEach(row => studentSet.add(row.userNo));
        this.distinctStudentCount = studentSet.size;

        this.aggregateChartData(resList);
      });
    },
    convertToDateTimeStr(isoStr) {
      if (!isoStr) return null;
      const date = new Date(isoStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .page-title {
    font-size: 20px;
    font-weight: 600;
    color: #B62D2E;
    margin: 0;
  }
}

.layout {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 16px;
}

.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: center;

    .el-input, .el-select {
      min-width: 140px;
    }

    .search-buttons {
      display: flex;
      gap: 8px;
    }
  }
}

/* 新增總數卡片樣式 */
.total-card {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .total-item {
    display: flex;
    flex-direction: column;
    min-width: 160px;
  }
  .total-label {
    font-size: 13px;
    color: #666;
  }
  .total-num {
    font-size: 22px;
    font-weight: bold;
    color: #B62D2E;
    margin-top: 4px;
  }
}

.chart-card {
  margin-bottom: 20px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 6px;

  .chart-title {
    margin: 0 0 12px 0;
    font-size: 16px;
    color: #303133;
  }

  .login-chart {
    width: 100%;
    height: 320px;
  }
}

.table-container {
  width: 100%;
}

@media (max-width: 768px) {
  .page {
    padding: 8px;
  }
  .layout {
    padding: 12px;
  }
  .search-row {
    flex-direction: column;
    align-items: stretch;
  }
  .pc-table {
    display: none;
  }
  .chart-card .login-chart {
    height: 240px;
  }
  .total-card {
    gap: 12px;
  }
}
</style>